import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import MetaFormInline from 'Components/UI/Meta/MetaForm/Components/MetaFormInline';
import { IdentityVerificationDecisionDialogOverride } from 'Overrides/identityVerificationReviewsOverride';
import IdentityVerificationDecisionLayout
  from 'Components/Modals/IdentityVerificationReviewDetails/decisionContent/DecisionLayout';

const styles = () => ({
  root: {},
  form: {
    height: '100%',
  },
});

const ReviewDecisionContent = ({
  className,
  classes,
  resource,
  onDecisionMade,
  onDecisionSubmitted,
  onBack,
}) => {
  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <MetaFormInline
        classes={{
          root: classNames(classes.root, className),
          form: classes.form,
        }}
        resource={resource}
        metaOverrideSet={IdentityVerificationDecisionDialogOverride}
        layout={IdentityVerificationDecisionLayout}
        LayoutProps={{
          onDecisionMade,
          onDecisionSubmitted,
          onBack,
          hideErrorList: true,
        }}
        readonly
      />
    </Box>
  );
};

ReviewDecisionContent.defaultProps = {
  className: '',
};

ReviewDecisionContent.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  resource: PropTypes.object.isRequired,
  onDecisionMade: PropTypes.func.isRequired,
  onDecisionSubmitted: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
};

export default withStyles(styles)(ReviewDecisionContent);
